export default {"src":"/_next/static/media/avax.9d53cbf0.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};